import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/style/index.scss'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'
import '@/assets/icon/font/iconfont.css'
import i18n from '@/locale'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(ElementPlus).use(i18n).use(store).use(router).mount('#app')
